"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const inputs_1 = require("..");
exports.DemoSelectBox = ({ resourceName, sharedProps, espId, listId, listEspId, integrationTypes, emailTemplateId, productionVersionId, stagingVersionId, developmentVersionId, cmsId, }) => {
    switch (resourceName) {
        case 'user':
            return (react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, Object.assign({ resource: resourceName, currentUserId: 1 }, sharedProps)));
        case 'email':
            return react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, Object.assign({ resource: "email" }, sharedProps));
        case 'emailList':
            return (react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, Object.assign({ resource: "emailList", espId: espId }, sharedProps)));
        case 'emailSegment':
            return (react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, Object.assign({ resource: resourceName, listEspId: listEspId, listId: listId, espId: espId }, sharedProps)));
        case 'context':
            return (react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, Object.assign({ resource: resourceName }, sharedProps)));
        case 'contentFeed':
            return (react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, Object.assign({ resource: resourceName }, sharedProps, { cmsId: cmsId })));
        case 'contentMapping':
            return (react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, Object.assign({ resource: resourceName }, sharedProps, { cmsId: cmsId })));
        case 'workspace':
            return (react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, Object.assign({ resource: resourceName }, sharedProps)));
        case 'ad':
            return (react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, Object.assign({ resource: resourceName }, sharedProps)));
        case 'contentConversion':
            return (react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, Object.assign({ resource: resourceName }, sharedProps)));
        case 'emailTemplate':
            return (react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, Object.assign({ resource: resourceName }, sharedProps)));
        case 'emailTemplateVersion':
            return (react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, Object.assign({ resource: resourceName }, sharedProps, { emailTemplateId: emailTemplateId, productionVersionId: productionVersionId, stagingVersionId: stagingVersionId, developmentVersionId: developmentVersionId })));
        case 'integration':
            return (react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, Object.assign({ resource: resourceName }, sharedProps, { integrationTypes: integrationTypes })));
        default:
            throw new Error(`Invalid resource: ${resourceName}`);
    }
};
//# sourceMappingURL=DemoSelectBox.js.map